module.exports = __webpack_public_path__ + "img/logo_ol_company_logo.964d705e.png";